
import objectAssign from 'object-assign'
import mentionsMixin from './mentions-mixin'
import SirTrevor from 'sir-trevor';

export default (function(){

  return SirTrevor.Blocks.List.extend(objectAssign({}, mentionsMixin, {

    controllable: true,

    controls: {
      'unorderedlist': function(e) {
        e.preventDefault();

        this.updateListType('unordered');
      },
      'orderedlist': function(e) {
        e.preventDefault();

        this.updateListType('ordered');
      }
    },

    scribeOptions: {
      allowBlockElements: false,
      tags: {
        p: false,
        a: true,
        span: true,
        b: true
      }
    },

    listTagName: function() {
      return (this.listType === 'ordered') ? 'ol' : 'ul';
    },

    createRootNode: function() {
      var el = document.createElement(this.listTagName());
      el.classList.add('st-list-block__list');
      return el;
    },

    // Data functions (loading, converting, saving)
    beforeLoadingData: function() {
      this.setupListVariables();
      this.initializeMentions();

      this.loadData(this._getData());
    },

    onBlockRender: function() {
      this.initializeMentions();

      if (!this.list) { this.setupListVariables(); }
      if (this.editorIds.length < 1) { this.addListItem(); }
    },

    setupListVariables: function() {
      this.list = this.inner.querySelector('ul, ol');
      this.listType = this.listType || 'unordered';
    },

    loadData: function(data) {
      if (this.options.convertFromMarkdown && data.format !== "html") {
        data = this.parseFromMarkdown(data.text);
      }

      while(Object.keys(this.editors).length) {
        var item = this.editors[Object.keys(this.editors)[0]];

        this.editorIds.splice(0, 1);
        this.list.removeChild(item.node);
        this.removeTextEditor(item.id);
      }

      this.listType = data.listType || 'unordered';

      this.list.parentNode.replaceChild(this.createRootNode(), this.list);

      this.setupListVariables();

      if (data.listItems.length) {
        data.listItems.forEach((li) => {
          this.addListItem(li.content);
        });
      } else {
        this.addListItem();
      }

      this.selectListTypeBtn();
    },

    selectListTypeBtn: function() {
      this.selectUiControl(`${this.listType}list`);
    },

    _serializeData: function() {
      var data = {
        format: 'html',
        listItems: [],
        listType: this.listType
      };

      this.editorIds.forEach(function(editorId) {
        let text = this.getTextEditor(editorId).scribe.getContent();
        var listItem = {
          content: this.getTextContentWithMentions(text)
        };
        data.listItems.push(listItem);
      }.bind(this));

      return data;
    },

    addListItem: function(content, after) {
      content = content || '';
      if (content.trim() === "<br>") { content = ''; }
      content = this.insertMentions(content);

      var editor = this.newTextEditor(this.listItemEditorHTML, content);

      editor.el.addEventListener('keypress', this.detectMentionStart.bind(this));
      editor.el.addEventListener('keyup', this.findMentions.bind(this));
      editor.el.addEventListener('keydown', (e) => {
        // Using keyboard keys to navigate mention suggestions
        // has behaviour conflicts with the list block
        // so degrading this feature for now, by stopping mentioning
        // when <enter> or <up arrow> are pressed
        if (e.keyCode === 13 || e.keyCode === 38) {
          this.stopMentioning();
        }
      });

      if (after && this.list.lastchild !== after.node) {
        var before = after.node.nextSibling;
        this.list.insertBefore(editor.node, before);

        var idx = this.editorIds.indexOf(after.id) + 1;
        this.editorIds.splice(idx, 0, editor.id);
      } else {
        this.list.appendChild(editor.node);
        this.editorIds.push(editor.id);
      }

      !content && this.focusOn(editor); // jshint ignore:line
    },

    removeCurrentListItem: function() {
      if (this.editorIds.length === 1) { return; }

      var item = this.getCurrentTextEditor();
      var idx = this.editorIds.indexOf(item.id);

      this.focusOnNeighbor(item);
      this.editorIds.splice(idx, 1);
      this.list.removeChild(item.node);
      this.removeTextEditor(item.id);
    },

    updateListType: function(listType) {
      var data = this._serializeData();
      data.listType = listType;
      this.setAndLoadData(data);
    }

  }))
})();
